var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getEditableField } from '../store/selectors';
import { removeUnicode } from '../../components/rich-text-editor';
import { buildApiPayloadImagesFromStore } from './images';
export var buildApiPayloadContentFromStore = function (params) {
    var state = params.store.getState();
    var result = {};
    var sendSmsField = getEditableField(state, 'sendSms');
    var sendPushField = getEditableField(state, 'sendPush');
    var sendEmailField = getEditableField(state, 'sendEmail');
    var smsBodyField = getEditableField(state, 'smsBody');
    var pushBodyField = getEditableField(state, 'pushBody');
    var emailBodyField = getEditableField(state, 'emailBody');
    var emailSubjectField = getEditableField(state, 'emailSubject');
    var emailTitleField = getEditableField(state, 'emailTitle');
    var ctaColorField = getEditableField(state, 'ctaColor');
    if (sendSmsField.value) {
        if (!smsBodyField.value && emailTitleField.value) {
            result.smsBody = removeUnicode(emailTitleField.value);
        }
        else if (smsBodyField.value) {
            result.smsBody = smsBodyField.value;
        }
    }
    else {
        result.smsBody = null;
    }
    if (sendPushField.value) {
        if (!pushBodyField.value && emailTitleField.value) {
            result.pushBody = emailTitleField.value;
        }
        else if (pushBodyField.value) {
            result.pushBody = pushBodyField.value;
        }
    }
    else {
        result.pushBody = null;
    }
    if (sendEmailField.value) {
        if (emailBodyField.value) {
            result.body = emailBodyField.value;
        }
        if (emailSubjectField.value) {
            result.subject = emailSubjectField.value;
        }
        if (emailTitleField.value) {
            result.title = emailTitleField.value;
        }
        if (ctaColorField.value) {
            result.color = ctaColorField.value;
        }
    }
    else {
        result.body = null;
        result.subject = null;
        result.title = null;
    }
    return __assign(__assign({}, result), buildApiPayloadImagesFromStore(params));
};
export var buildStoreContentFromApiCampaign = function (_a) {
    var campaign = _a.campaign;
    var subject = campaign.subject, body = campaign.body, title = campaign.title, smsBody = campaign.smsBody, pushBody = campaign.pushBody, color = campaign.color;
    return {
        smsBody: { value: smsBody || null },
        pushBody: { value: pushBody || null },
        emailBody: { value: body || null },
        emailSubject: { value: subject || null },
        emailTitle: { value: title || null },
        ctaColor: { value: color || null },
    };
};
